import { FormOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Drawers } from 'app/types/drawer';
import { useOpenDrawerHandler } from 'hooks/useOpenDrawerHandler';
import { Button } from 'antd';
import { Can } from 'components';
import { User } from 'constants/index';

interface AddButtonProps {
  sampleId: number,
  result?: boolean,
  statement?: string,
  hasResult: boolean
}

const Add = ({ sampleId, result, statement, hasResult }: AddButtonProps) => {
  const { t } = useTranslation();

  const handleClick = useOpenDrawerHandler({
    key: Drawers.ADD_STATEMENT,
    title: hasResult ? t('forms.statement.edit') : t('forms.statement.add'),
    props: {
      id: sampleId,
      result,
      statement,
    }
  });

  return (
    <Can requiredPermission={User.Permissions.MANAGE_RESULTS}>
      <Button className='full-width' type='primary' onClick={handleClick} icon={<FormOutlined />}>
        {hasResult ? t('forms.statement.edit') : t('forms.statement.add')}
      </Button>
    </Can>
  );
};

export default Add;